/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';

/**
 * 
 * @export
 * @interface ReTryContactActionRequestContent
 */
export interface ReTryContactActionRequestContent {
    /**
     * 
     * @type {CallingIdentity}
     * @memberof ReTryContactActionRequestContent
     */
    callingIdentity: CallingIdentity;
}


/**
 * Check if a given object implements the ReTryContactActionRequestContent interface.
 */
export function instanceOfReTryContactActionRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "callingIdentity" in value;

    return isInstance;
}

export function ReTryContactActionRequestContentFromJSON(json: any): ReTryContactActionRequestContent {
    return ReTryContactActionRequestContentFromJSONTyped(json, false);
}

export function ReTryContactActionRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReTryContactActionRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'callingIdentity': CallingIdentityFromJSON(json['callingIdentity']),
    };
}

export function ReTryContactActionRequestContentToJSON(value?: ReTryContactActionRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'callingIdentity': CallingIdentityToJSON(value.callingIdentity),
    };
}

